// extracted by mini-css-extract-plugin
export default {"modal":"BN-z","error":"CN-z","disabled":"DN-z","fields":"EN-z","errorMsg":"FN-z","footer":"GN-z","formContentWrapper":"HN-z","productImage":"IN-z","overlay":"JN-z"};